"use client";

import { c as _c } from "react/compiler-runtime";
import { BasketIcon } from "@local/ui/src/components/ui/icons";
import { cn } from "@local/utils/src/cn";
import { useState } from "react";
interface CartButtonProps {
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
  ariaLabel?: string;
  count?: number;
  showCount?: boolean;
  /**
   * True once the client-side cart count has hydrated. When false, the diff
   * announcer treats every incoming `count` as the baseline and stays silent.
   * Parents that render a placeholder count during SSR (e.g.
   * TopNavigationBarClient passes `0` until `hasMounted`) must pass this so
   * the jump from placeholder to real count is not mistaken for an addition.
   * Defaults to `true` for callers with no hydration placeholder.
   */
  ready?: boolean;
}
export const CartButton = t0 => {
  const $ = _c(20);
  const {
    onClick,
    className,
    iconClassName,
    ariaLabel: t1,
    count: t2,
    showCount: t3,
    ready: t4
  } = t0;
  const ariaLabel = t1 === undefined ? "Shopping cart" : t1;
  const count = t2 === undefined ? 0 : t2;
  const showCount = t3 === undefined ? true : t3;
  const ready = t4 === undefined ? true : t4;
  const itemLabel = count === 0 ? "empty" : `${count} ${count === 1 ? "item" : "items"}`;
  const [lastCount, setLastCount] = useState(null);
  const [announcement, setAnnouncement] = useState("");
  if (ready && lastCount !== count) {
    setLastCount(count);
    if (lastCount !== null) {
      const totalLabel = count === 1 ? "1 item total" : `${count} items total`;
      setAnnouncement(count > lastCount ? `Added to cart. ${totalLabel}.` : `Removed from cart. ${totalLabel}.`);
    }
  }
  let t5;
  if ($[0] !== className) {
    t5 = cn("relative flex aspect-square h-full cursor-pointer flex-row items-center justify-center sm:mr-1 sm:gap-3 md:mr-4", className);
    $[0] = className;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = `${ariaLabel}, ${itemLabel}`;
  const t7 = showCount && count > 0 && "md:border-r md:border-r-white md:pr-3 md:pl-1";
  let t8;
  if ($[2] !== iconClassName || $[3] !== t7) {
    t8 = cn("sm:static md:text-sm", t7, iconClassName);
    $[2] = iconClassName;
    $[3] = t7;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <BasketIcon />;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== t8) {
    t10 = <div className={t8}>{t9}</div>;
    $[6] = t8;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== count || $[9] !== showCount) {
    t11 = showCount && count > 0 && <span aria-hidden="true" className="absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-red-400 text-sm md:static md:top-auto md:right-auto md:h-auto md:w-auto md:rounded-none md:bg-transparent">{count}</span>;
    $[8] = count;
    $[9] = showCount;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== announcement) {
    t12 = <span role="status" aria-live="polite" aria-atomic="true" className="sr-only">{announcement}</span>;
    $[11] = announcement;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== onClick || $[14] !== t10 || $[15] !== t11 || $[16] !== t12 || $[17] !== t5 || $[18] !== t6) {
    t13 = <button type="button" className={t5} aria-label={t6} onClick={onClick}>{t10}{t11}{t12}</button>;
    $[13] = onClick;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t5;
    $[18] = t6;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  return t13;
};